import { Processing } from "@wg/wows-react-uikit";
import { connect } from "react-redux";

const mapStateToProps = state => ({
  isFetching: state.fetchingCounter.counter > 0,
  label: state.fetchingCounter.text
});

export default connect(mapStateToProps)(Processing);